import React, { useState, useEffect } from "react";
import { DateBox, LoadPanel, Popup } from "devextreme-react";
import "../financialPop.css";
import { handleGetLocal } from "../../../../../../services/auth-service";
import axios from "axios";
import { ColumnDropdown } from "../../../../../../components/Dropdownn";
import { EditConfirmMessage } from "./EditConfirmMessage";
import { logOut } from "../../../../../../components/Logout";
import { useNavigate } from "react-router-dom";
import { getDateBoxFormat } from "../../../../../Dateapi/dateFormatter";
import { useScreenPermission } from "../../../../../../hooks/useScreenPermission";

const DropDown = ({ dropDownData, setfields, fields, fieldNmae, reset, paymentMethod, disabled }) => {
  return (
    <>
      <ColumnDropdown
        data={dropDownData}
        setfields={setfields}
        fields={fields}
        fieldNmae={fieldNmae}
        value={fields[fieldNmae]?.name || paymentMethod}
        // reset={reset}
        disabled={disabled}
      />
    </>
  );
};

export const EditPopup = ({
  setEditPopup,
  listData,
  paymnetMethodData,
  rowInfoData,
  setCallApi,
  callApi,
  toastConfig,
  setToastConfig,
  paymentDate,
  transactionId,
  paymentMethod,
  cashDrawer,
}) => {
  const [loading, setLoading] = useState(false);
  const [dateValidation, setDateValidation] = useState("");
  const [editConfirmPopup, setEditConfirmPopup] = useState(false);
  const [isFinancialPeriodClosed, setIsFinancialPeriodClosed] = useState(false);
  const [financialCloseMessage, setFinancialCloseMessage] = useState("");
  const [fields, setfields] = useState({
    paymentDate: "",
    cashDrawer: {
      name: rowInfoData?.[`Cash Drawer`],
      id: rowInfoData?.gCashDrawerId,
    },
    paymentMethod: {
      name: rowInfoData?.[`Payment Method`],
      id: rowInfoData?.gPaymentMethodId,
    },
    reference: "",
    transactionID: "",
    manualReceipt: "",
    description: "",
  });

  useEffect(() => {
    const selectedPaymentMethod = paymnetMethodData
      ?.map((item) => ({
        name: item?.value,
        id: item?.key,
      }))
      ?.find((item) => item.name === rowInfoData?.[`Payment Method`] || item.name === paymentMethod);

    const selectedCashDrawer = listData
      ?.map((item) => ({
        name: item?.value,
        id: item?.key,
      }))
      ?.find((item) => item.name === rowInfoData?.[`Cash Drawer`] || item.name === cashDrawer);

    setfields((prev) => ({
      ...prev,
      paymentDate: rowInfoData?.[`Date of Receipt`] || rowInfoData?.Date || paymentDate,
      cashDrawer: selectedCashDrawer || {
        name: rowInfoData?.[`Cash Drawer`] || cashDrawer,
        id: rowInfoData?.gCashDrawerId,
      },
      paymentMethod: selectedPaymentMethod || {
        name: rowInfoData?.[`Payment Method`] || paymentMethod,
        id: rowInfoData?.gPaymentMethodId,
      },
      reference: rowInfoData?.Reference || "",
      transactionID: transactionId ? transactionId : rowInfoData?.[`Transaction ID`] || "",
      manualReceipt: rowInfoData?.sManualReceiptNumber || "",
      description: rowInfoData?.sReceiptNote || "",
    }));
  }, [rowInfoData, transactionId, paymentMethod, cashDrawer, paymnetMethodData, listData, paymentDate]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setfields((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSave = () => {
    if (isFinancialPeriodClosed) {
      setToastConfig({
        ...toastConfig,
        isVisible: true,
        message: financialCloseMessage || "This financial period is closed. This payment cannot be edited.",
        type: "error",
      });

      return;
    }
    if (!permission.edit) {
      setToastConfig({
        ...toastConfig,
        isVisible: true,
        message: "You do not have Edit access for PY.4.",
        type: "error",
      });

      setTimeout(() => {
        setToastConfig({
          ...toastConfig,
          isVisible: false,
          message: "",
          type: "",
        });
      }, 1400);

      return;
    }
    const selectedDate = new Date(fields.paymentDate);
    const currentDate = new Date();
    const currentDateWithoutTime = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
    const minAllowedDate = new Date();
    minAllowedDate.setDate(currentDateWithoutTime.getDate() - 30);

    if (selectedDate > currentDateWithoutTime) {
      setDateValidation("Payment Date cannot be in the future");
    } else if (selectedDate < minAllowedDate) {
      setEditConfirmPopup(true);
    } else {
      saveApi();
      setDateValidation("");
    }
  };

  const navigate = useNavigate();
  const SCREEN_NAME = "PY4";
  const { permission, permissionLoading } = useScreenPermission(SCREEN_NAME, navigate);

  const saveApi = async () => {
    setLoading(true);

    const pathname = handleGetLocal("pathURL");

    const data = {
      paymentID: rowInfoData?.gPaymentId,
      dReceipt: fields.paymentDate,
      paymentMethodID: fields.paymentMethod?.id,
      reference: fields.reference || "",
      cC_TransactionID: fields.transactionID || "",
      manualReceiptNumber: fields.manualReceipt || "",
      cashDrawerID: fields.cashDrawer?.id,
      receiptNote: fields.description || "",
    };

    console.log("update-payment payload", data);

    try {
      const val = await axios.post(`${process.env.REACT_APP_API_URL}/api/Payment/update-payment`, data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          Domain: `${pathname}`,
        },
      });

      console.log("update-payment response", val?.data);

      setLoading(false);

      if (val?.data?.isSuccess) {
        setEditPopup(false);

        setToastConfig({
          isVisible: true,
          message: val?.data?.responseMessage || "Payment has been updated",
          type: "success",
        });

        setTimeout(() => {
          setToastConfig({
            isVisible: false,
            message: "",
            type: "",
          });
        }, 1900);

        if (typeof setCallApi === "function") {
          setCallApi((prev) => !prev);
        }

        return;
      }

      setToastConfig({
        isVisible: true,
        message: val?.data?.responseMessage || "Payment update failed",
        type: "error",
      });

      setTimeout(() => {
        setToastConfig({
          isVisible: false,
          message: "",
          type: "",
        });
      }, 1900);
    } catch (error) {
      setLoading(false);

      console.log("update-payment error", error);

      if (error?.response?.status === 401) {
        logOut();
        return;
      }

      setToastConfig({
        isVisible: true,
        message:
          error?.response?.data?.message ||
          error?.response?.data?.Message ||
          "Something went wrong while updating payment.",
        type: "error",
      });

      setTimeout(() => {
        setToastConfig({
          isVisible: false,
          message: "",
          type: "",
        });
      }, 1900);
    }
  };

  useEffect(() => {
    const originalPaymentDate = rowInfoData?.["Date of Receipt"] || rowInfoData?.Date || paymentDate;

    if (!originalPaymentDate) {
      setIsFinancialPeriodClosed(false);
      setFinancialCloseMessage("");
      return;
    }

    const pathname = handleGetLocal("pathURL");

    setLoading(true);

    axios
      .get(`${process.env.REACT_APP_API_URL}/api/Financial/financial-period-status`, {
        params: {
          financialDate: originalPaymentDate,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          Domain: pathname,
        },
      })
      .then((response) => {
        const result = response?.data;

        if (result?.isSuccess && result?.data) {
          const closed = result.data.isClosed;

          setIsFinancialPeriodClosed(closed);

          if (closed) {
            setFinancialCloseMessage(
              `The financial period for ${result.data.financialMonth} is closed. ` +
                `The close date was ${new Date(
                  result.data.closeDate,
                ).toLocaleDateString()}. This payment cannot be edited.`,
            );
          } else {
            setFinancialCloseMessage("");
          }
        } else {
          setIsFinancialPeriodClosed(false);
          setFinancialCloseMessage("");
        }
      })
      .catch((error) => {
        console.log("financial-period-status error", error);

        setIsFinancialPeriodClosed(false);
        setFinancialCloseMessage("");

        if (error?.response?.status === 401) {
          logOut();
        }
      })
      .finally(() => {
        setLoading(false);
      });
  }, [rowInfoData, paymentDate]);

  return (
    <>
      <LoadPanel shadingColor="true" visible={loading || permissionLoading} delay={10} />
      <div className="edit_payment">
        {!permission.view ? (
          <>
            <div className="popup_header">
              <div className="popup_header_title">
                <div className="popup_header_title_data">
                  <p>No PY.4 View Access</p>
                </div>
              </div>

              <svg
                onClick={() => {
                  setEditPopup(false);
                }}
                style={{ cursor: "pointer" }}
                width="10"
                height="10"
                viewBox="0 0 10 10"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9.72406 0.282539C9.43156 -0.00996077 8.95906 -0.00996077 8.66656 0.282539L4.99906 3.94254L1.33156 0.275039C1.03906 -0.0174609 0.566563 -0.0174609 0.274063 0.275039C-0.0184375 0.567539 -0.0184375 1.04004 0.274063 1.33254L3.94156 5.00004L0.274063 8.66754C-0.0184375 8.96004 -0.0184375 9.43254 0.274063 9.72504C0.566563 10.0175 1.03906 10.0175 1.33156 9.72504L4.99906 6.05754L8.66656 9.72504C8.95906 10.0175 9.43156 10.0175 9.72406 9.72504C10.0166 9.43254 10.0166 8.96004 9.72406 8.66754L6.05656 5.00004L9.72406 1.33254C10.0091 1.04754 10.0091 0.567539 9.72406 0.282539Z"
                  fill="white"
                />
              </svg>
            </div>

            <div style={{ padding: "20px", fontWeight: 600 }}>You do not have View access for PY.4.</div>
          </>
        ) : (
          <>
            <Popup
              visible={editConfirmPopup}
              onHiding={() => {
                setEditConfirmPopup(false);
              }}
              showTitle={false}
              width={590}
              height={230}
              showCloseButton={true}
              hideOnOutsideClick={false}
            >
              <EditConfirmMessage setEditConfirmPopup={setEditConfirmPopup} saveApi={saveApi} />
            </Popup>
            <div className="popup_header">
              <div className="popup_header_title">
                <div class="popup_header_title_data">
                  <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M0 15.4586V18.4986C0 18.7786 0.22 18.9986 0.5 18.9986H3.54C3.67 18.9986 3.8 18.9486 3.89 18.8486L14.81 7.93859L11.06 4.18859L0.15 15.0986C0.0500001 15.1986 0 15.3186 0 15.4586ZM17.71 5.03859C18.1 4.64859 18.1 4.01859 17.71 3.62859L15.37 1.28859C14.98 0.898594 14.35 0.898594 13.96 1.28859L12.13 3.11859L15.88 6.86859L17.71 5.03859Z"
                      fill="white"
                    />
                  </svg>
                  <p>Edit Payment</p>
                </div>
                <p class="popup_header_title_para">PY.4</p>
              </div>
              <svg
                onClick={() => {
                  setEditPopup(false);
                  setfields((prev) => ({
                    ...prev,
                    paymentDate: "",
                    cashDrawer: "",
                    paymentMethod: "",
                    reference: "",
                    transactionID: "",
                    manualReceipt: "",
                    description: "",
                  }));
                }}
                style={{
                  cursor: "pointer",
                }}
                width="10"
                height="10"
                viewBox="0 0 10 10"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9.72406 0.282539C9.43156 -0.00996077 8.95906 -0.00996077 8.66656 0.282539L4.99906 3.94254L1.33156 0.275039C1.03906 -0.0174609 0.566563 -0.0174609 0.274063 0.275039C-0.0184375 0.567539 -0.0184375 1.04004 0.274063 1.33254L3.94156 5.00004L0.274063 8.66754C-0.0184375 8.96004 -0.0184375 9.43254 0.274063 9.72504C0.566563 10.0175 1.03906 10.0175 1.33156 9.72504L4.99906 6.05754L8.66656 9.72504C8.95906 10.0175 9.43156 10.0175 9.72406 9.72504C10.0166 9.43254 10.0166 8.96004 9.72406 8.66754L6.05656 5.00004L9.72406 1.33254C10.0091 1.04754 10.0091 0.567539 9.72406 0.282539Z"
                  fill="white"
                />
              </svg>
            </div>
            {isFinancialPeriodClosed && <div className="financial_close_warning">{financialCloseMessage}</div>}
            <div className="edit_container">
              <div className="edit_container_first">
                <div className="edit_content_flex">
                  <p className="edit_container_label">Payment Date</p>
                  <DateBox
                    displayFormat={getDateBoxFormat()}
                    value={fields.paymentDate || paymentDate}
                    disabled={isFinancialPeriodClosed}
                    onValueChange={(e) => {
                      setfields((prev) => ({
                        ...prev,
                        paymentDate: e,
                      }));
                      setDateValidation("");
                    }}
                    useMaskBehavior={true}
                  />
                  <p className="error_validation customize_error">{dateValidation}</p>
                </div>
                <div className="edit_content_flex edit_content_space">
                  <p className="edit_container_label">Payment Method</p>
                  <DropDown
                    paymentMethod={paymentMethod}
                    setfields={setfields}
                    fields={fields}
                    disabled={isFinancialPeriodClosed}
                    fieldNmae={"paymentMethod"}
                    dropDownData={paymnetMethodData?.map((vall) => {
                      return {
                        name: vall?.value,
                        id: vall?.key,
                      };
                    })}
                  />
                </div>
              </div>
              <div className="edit_container_first">
                <div className="edit_content_flex">
                  <p className="edit_container_label">Reference</p>
                  <input
                    id="reference"
                    name="reference"
                    type="text"
                    placeholder="Enter reference number"
                    className="edit_container_input"
                    value={fields.reference}
                    onChange={handleInputChange}
                    disabled={isFinancialPeriodClosed}
                  />
                </div>
                <div className="edit_content_flex">
                  <p className="edit_container_label">Transaction ID</p>
                  <input
                    id="transactionID"
                    name="transactionID"
                    type="number"
                    placeholder="Enter transaction ID"
                    className="edit_container_input"
                    value={fields.transactionID}
                    onChange={handleInputChange}
                    disabled
                  />
                </div>
              </div>
              <div className="edit_container_first">
                <div className="edit_content_flex">
                  <p className="edit_container_label">Manual Receipt #</p>
                  <input
                    id="manualReceipt"
                    name="manualReceipt"
                    type="text"
                    className="edit_container_input"
                    value={fields.manualReceipt}
                    onChange={handleInputChange}
                    placeholder="Enter Manual Receipt"
                    disabled={isFinancialPeriodClosed}
                  />
                </div>
                <div className="edit_content_flex edit_content_space">
                  <p className="edit_container_label">Cash Drawer</p>
                  <DropDown
                    setfields={setfields}
                    fields={fields}
                    disabled={isFinancialPeriodClosed}
                    paymentMethod={cashDrawer}
                    fieldNmae={"cashDrawer"}
                    dropDownData={listData?.map((vall) => {
                      return {
                        name: vall?.value,
                        id: vall?.key,
                      };
                    })}
                  />
                </div>
              </div>
              <div className="edit_container_second edit_content_flex">
                <p className="edit_container_label">Receipt Note</p>
                <textarea
                  name="description"
                  id="description"
                  placeholder="Write Receipt Note"
                  value={fields.description}
                  onChange={handleInputChange}
                  disabled={isFinancialPeriodClosed}
                ></textarea>
              </div>
              <div className="edit_container_second_alert">
                NOTE : Changes made to this payment may effect previously printed reports. Please use caution when
                making changes
              </div>
            </div>
            <div className="popup_buttons">
              <button
                className="btn primary_btn"
                disabled={!permission.edit || isFinancialPeriodClosed}
                style={{
                  opacity: permission.edit && !isFinancialPeriodClosed ? 1 : 0.6,
                  cursor: permission.edit && !isFinancialPeriodClosed ? "pointer" : "not-allowed",
                }}
                onClick={() => {
                  handleSave();
                }}
              >
                Save
              </button>
              <button
                className="btn edit_payment_btn"
                onClick={() => {
                  setEditPopup(false);
                }}
              >
                Cancel
              </button>
            </div>
          </>
        )}
      </div>
    </>
  );
};
